The input parameter for the `applicationLibraryQuestionSearch` query.
